module.exports = __webpack_public_path__ + "img/total.98ffff6f.png";